export const STYLE_INJECTION_CONTAINER_ID = 'epilot-injected-styles'
export const PORTAL_CONTAINER_ID = 'epilot-portal-container'
